
import React, { useState } from 'react';

const STORAGE_KEY = 'orion_cookie_notice_dismissed';

const CookieBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState<boolean>(
    () => localStorage.getItem(STORAGE_KEY) === '1'
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  return (
    <div
      role="region"
      aria-label="Information cookies"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-4 px-6 py-3.5"
      style={{
        background: 'linear-gradient(90deg, rgba(10,18,42,0.97) 0%, rgba(13,24,54,0.97) 100%)',
        borderTop: '1px solid rgba(100,140,210,0.22)',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.4)',
      }}
    >
      {/* Icône + texte */}
      <div className="flex items-center gap-3 min-w-0">
        <div
          className="flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-sm"
          style={{ background: 'rgba(17,197,214,0.12)', color: '#11c5d6' }}
        >
          🍪
        </div>
        <p className="text-[11px] text-[#7f93bc] leading-snug truncate">
          Ce site utilise uniquement des{' '}
          <span className="text-[#a8c0e8] font-semibold">cookies strictement nécessaires</span>
          {' '}à l'authentification. Aucun cookie publicitaire ou de traçage.{' '}
          <a
            href="/politique-de-confidentialite"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#11c5d6] hover:underline font-semibold whitespace-nowrap"
          >
            En savoir plus
          </a>
        </p>
      </div>

      {/* Bouton */}
      <button
        type="button"
        onClick={handleDismiss}
        className="flex-shrink-0 px-4 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-wider transition-all"
        style={{
          background: 'rgba(17,197,214,0.12)',
          color: '#11c5d6',
          border: '1px solid rgba(17,197,214,0.25)',
        }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLButtonElement).style.background = 'rgba(17,197,214,0.22)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLButtonElement).style.background = 'rgba(17,197,214,0.12)';
        }}
      >
        J'ai compris
      </button>
    </div>
  );
};

export default CookieBanner;
